/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ActorActivityRecordActorUserId } from './ActorActivityRecordActorUserId';
import {
    ActorActivityRecordActorUserIdFromJSON,
    ActorActivityRecordActorUserIdFromJSONTyped,
    ActorActivityRecordActorUserIdToJSON,
    ActorActivityRecordActorUserIdToJSONTyped,
} from './ActorActivityRecordActorUserId';

/**
 * 
 * @export
 * @interface GetPayrollLedgerEntryRequest
 */
export interface GetPayrollLedgerEntryRequest {
    /**
     * 
     * @type {ActorActivityRecordActorUserId}
     * @memberof GetPayrollLedgerEntryRequest
     */
    userId?: ActorActivityRecordActorUserId | null;
    /**
     * 
     * @type {ActorActivityRecordActorUserId}
     * @memberof GetPayrollLedgerEntryRequest
     */
    entryTypeId?: ActorActivityRecordActorUserId | null;
    /**
     * 
     * @type {any}
     * @memberof GetPayrollLedgerEntryRequest
     */
    fromDate?: any | null;
    /**
     * 
     * @type {any}
     * @memberof GetPayrollLedgerEntryRequest
     */
    toDate?: any | null;
}

/**
 * Check if a given object implements the GetPayrollLedgerEntryRequest interface.
 */
export function instanceOfGetPayrollLedgerEntryRequest(value: object): value is GetPayrollLedgerEntryRequest {
    return true;
}

export function GetPayrollLedgerEntryRequestFromJSON(json: any): GetPayrollLedgerEntryRequest {
    return GetPayrollLedgerEntryRequestFromJSONTyped(json, false);
}

export function GetPayrollLedgerEntryRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetPayrollLedgerEntryRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'userId': json['userId'] == null ? undefined : ActorActivityRecordActorUserIdFromJSON(json['userId']),
        'entryTypeId': json['entryTypeId'] == null ? undefined : ActorActivityRecordActorUserIdFromJSON(json['entryTypeId']),
        'fromDate': json['fromDate'] == null ? undefined : json['fromDate'],
        'toDate': json['toDate'] == null ? undefined : json['toDate'],
    };
}

export function GetPayrollLedgerEntryRequestToJSON(json: any): GetPayrollLedgerEntryRequest {
    return GetPayrollLedgerEntryRequestToJSONTyped(json, false);
}

export function GetPayrollLedgerEntryRequestToJSONTyped(value?: GetPayrollLedgerEntryRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userId': ActorActivityRecordActorUserIdToJSON(value['userId']),
        'entryTypeId': ActorActivityRecordActorUserIdToJSON(value['entryTypeId']),
        'fromDate': value['fromDate'],
        'toDate': value['toDate'],
    };
}

